import React, { SetStateAction, Dispatch } from 'react'
import { BasePagination, PaginationNavGroup, PaginationNextButton, PaginationFirstButton, PaginationPrevButton } from '@amzn/storm-ui'
import { PaginationNavContainer } from '../../manage_shared.styles'
import { skeletonWhileLoading } from '../../../../../util/skeleton_loading'
import { getPrevCursor, PrevCursor } from './advertisers_helper'
import { useTranslation } from 'react-i18next'

interface AdvertisersPaginationProps {
  loading: boolean
  cursor: string | null
  setCursor: Dispatch<SetStateAction<string | null>>
  pageNum: number
  setPageNum: Dispatch<SetStateAction<number>>
  prevCursors: PrevCursor[]
  hasNextPage: boolean | null | undefined
}
export const AdvertisersPagination: React.FunctionComponent<AdvertisersPaginationProps> = (props: AdvertisersPaginationProps): JSX.Element => {
  const { t } = useTranslation()

  const { loading, cursor, setCursor, pageNum, setPageNum, prevCursors, hasNextPage } = props
  const skeletonize = skeletonWhileLoading(loading)
  const onNextPage = (): void => {
    setCursor(cursor)
    setPageNum((pageNum) => pageNum + 1)
  }

  const onPrevPage = (): void => {
    const cursor = getPrevCursor(pageNum - 1, prevCursors)
    setCursor(cursor.after ?? null)
    setPageNum((pageNum) => pageNum - 1)
  }
  const onFirstPage = (): void => {
    setCursor(null)
    setPageNum(0)
  }
  return (
    <PaginationNavContainer>
      {skeletonize(
        <BasePagination>
          <PaginationNavGroup>
            <PaginationFirstButton
              id="shared-advertisers-first-page-button"
              ariaLabel={t('SHARED:PAGINATION:FIRST_PAGE_LABEL')}
              onClick={onFirstPage}
              disabled={pageNum === 0}
            />
            <PaginationPrevButton
              id="shared-advertisers-prev-page-button"
              ariaLabel={t('SHARED:PAGINATION:PREV_PAGE_LABEL')}
              onClick={onPrevPage}
              disabled={pageNum === 0}
            />
            <PaginationNextButton
              id="shared-advertisers-next-page-button"
              ariaLabel={t('SHARED:PAGINATION:NEXT_PAGE_LABEL')}
              onClick={onNextPage}
              disabled={!hasNextPage}
            />
          </PaginationNavGroup>
        </BasePagination>,
        { width: 100, height: 25 },
      )}
    </PaginationNavContainer>
  )
}
